<template>
  <div class="search-group">
    <b-select
      v-model="selecionado"
      name="filtroSelecao"
      class="search-items"
      @select="placeholder = false"
      @input="enviarParaPai()"
    >
      <option
        :value="null"
        disabled
        hidden
      >{{ filtroNome }}</option>

      <option
        key="_blank"
        :value="null"
      />

      <option
        v-for="(filtro, index) in filtros"
        :key="index"
        :value="filtro"
        :class="filtro.classe"
      >
        <b-form-checkbox
          id="checkbox-1"
          v-model="status"
          name="checkbox-1"
          value="accepted"
          unchecked-value="not_accepted"
        > {{ filtro.label }} </b-form-checkbox>
        <!-- <input
          :id="index"
          v-model="aaaaa"
          type="checkbox"
        > -->
      </option>
    </b-select>
    <!-- :class="{'opcao-titulo': filtro.titulo}"
      :disabled="filtro.titulo" -->
    <label
      name="filtroLabel"
      for="filter"
      class="fas fa-filter icon"
    />
  </div>
</template>
<style >
.opcao-titulo {
  font-weight: bold;
}
</style>
<script>
export default {
  props: {
    filtros: {
      type: [Array, Boolean],
      default: false,
    },
    filtroAtual: {
      type: Object,
      default: () => {},
    },
    filtroNome: {
      type: String,
      default: 'Filtro',
    },
  },
  data() {
    return {
      placeholder: false,
      selecionado: null,
      status: null,
      // Último valor emitido por ESTE componente, para o watch não reemitir o que voltou do pai.
      ultimoEmitido: null,
    }
  },
  watch: {
    // O emit aqui é necessário: telas como a Caixa Postal aplicam o filtro só atribuindo
    // "filtroAtual" (deep-link ?dias=), sem chamar aplicarFiltroRapido.
    // Mas ele não pode reentrar quando o valor já veio deste próprio select:
    // aplicarFiltroRapido é justamente quem altera "filtroAtual", e a volta chegaria
    // com filtroInterno = true (o default), caindo no findIndex(filtroInterno) que remove
    // do array o filtro extra recém-aplicado (ex.: o período de apuração do card 48433).
    // Valor fora das opções é ignorado: ele não pertence a este select, e sincronizá-lo
    // dispararia o mesmo caminho reentrante com um filtro que é de outro controle.
    filtroAtual(val, oldVal) {
      if (val === oldVal) { return }
      const opcao = val == null ? null : this.acharOpcao(val)
      if (val != null && opcao === undefined) {
        // O pai passou a um filtro de outro controle: o que este select emitiu deixou
        // de ser o filtro corrente, então zera para não bloquear o reenvio do mesmo
        // valor quando ele voltar.
        this.ultimoEmitido = null
        return
      }
      // Sincroniza com a OPÇÃO da lista: atribuir ao v-model um objeto que não é um dos
      // :value das <option> deixaria o <b-select> em branco com o filtro aplicado.
      this.selecionado = opcao
      this.enviarParaPai()
    },
  },
  created() {
    const opcaoInicial = this.filtroAtual ? this.acharOpcao(this.filtroAtual) : undefined
    if (opcaoInicial !== undefined) {
      this.selecionado = opcaoInicial
      this.enviarParaPai()
    }
  },
  methods: {
    // Devolve a OPÇÃO equivalente ao valor (identidade ou mesmo id), ou undefined.
    // O fallback por id existe porque a comparação por identidade quebraria se algum dia
    // "filtros" virar um computed que reconstrói o array — e a falha seria silenciosa.
    // Devolver a opção (e não só true/false) é o que mantém o <b-select> sincronizado:
    // atribuir ao v-model um objeto fora da lista deixaria o select em branco.
    acharOpcao(valor) {
      if (!Array.isArray(this.filtros)) { return undefined }
      return this.filtros.find(f => f === valor || (f.id != null && valor.id != null && f.id === valor.id))
    },
    enviarParaPai() {
      // Reemitir o mesmo valor é sempre redundante e reentra em aplicarFiltroRapido.
      // Guarda única das duas portas: o watch acima e o input que o próprio b-form-select
      // dispara quando "selecionado" é alterado por código.
      // Normaliza ANTES de comparar: aplicarFiltroRapido reconhece a limpeza por "=== null",
      // e guardar o valor cru faria uma transição undefined -> null reemitir à toa.
      const valor = this.selecionado === undefined ? null : this.selecionado
      if (valor === this.ultimoEmitido) { return }
      this.ultimoEmitido = valor
      this.$emit('selecionado', valor)
    },
  },
}
</script>
